var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Redirect, Router, withRouter, useLocation, useHistory, } from 'react-router-dom';
import PortalRouter from './portal_router';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '@doordash/component-loading';
import { isFetchPending, isFetchFulfilled, isFetchRejected, } from '../../utils/fetchStatusHelper';
import { fetchPortalData } from './portal_slice';
import { PortalActions } from '../../constants/actions/types';
import { PORTAL_ROUTE_PREFIX, ERROR_MESSAGE_TEAM_NOT_FOUND, } from '../../constants/values';
import { getStatusForPortalAction } from '../../selectors/portal_selector';
import PageNotFound from '../page_not_found';
import RedirectTo from '../RedirectTo';
export var isOnAdminRoute = function (pathName) {
    return pathName.startsWith(PORTAL_ROUTE_PREFIX + "/admin/");
};
export var isOnRedirectPageRoute = function (pathName) {
    return pathName.startsWith(PORTAL_ROUTE_PREFIX + "/redirect-to");
};
export var shouldRedirectToTeamNotFound = function (statusForPortalAction, errorMessage) {
    return (isFetchRejected(statusForPortalAction, PortalActions.FETCH_PORTAL_DATA) &&
        errorMessage === ERROR_MESSAGE_TEAM_NOT_FOUND);
};
export var PortalContainer = function () {
    var dispatch = useDispatch();
    var statusForPortalAction = useSelector(getStatusForPortalAction);
    var location = useLocation();
    var history = useHistory();
    var _a = __read(React.useState(null), 2), errorMsg = _a[0], setErrorMsg = _a[1];
    var handleFetchPortalDataSuccess = React.useCallback(function () {
        setErrorMsg(null);
    }, [setErrorMsg]);
    var handleFetchPortalDataError = React.useCallback(function (errorResponse) {
        setErrorMsg(errorResponse.error || 'There was an error.');
    }, [setErrorMsg]);
    React.useEffect(function () {
        var mountOnAdminRoute = isOnAdminRoute((history && history.location && history.location.pathname) || '');
        var options = {
            skipAutoSelectingTeamAccount: !!mountOnAdminRoute,
        };
        dispatch(fetchPortalData(options))
            .unwrap()
            .then(handleFetchPortalDataSuccess, handleFetchPortalDataError);
    }, [
        handleFetchPortalDataSuccess,
        handleFetchPortalDataError,
        dispatch,
        history,
    ]);
    if (isOnRedirectPageRoute(location.pathname)) {
        return (React.createElement(RedirectTo, { history: history, matchedPath: PORTAL_ROUTE_PREFIX + "/redirect-to", pathname: location === null || location === void 0 ? void 0 : location.pathname }));
    }
    if (isFetchPending(statusForPortalAction, PortalActions.FETCH_PORTAL_DATA)) {
        return (React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 }));
    }
    if (shouldRedirectToTeamNotFound(statusForPortalAction, errorMsg || '')) {
        return React.createElement(Redirect, { to: PORTAL_ROUTE_PREFIX + "/team-not-found" });
    }
    if (isFetchFulfilled(statusForPortalAction, PortalActions.FETCH_PORTAL_DATA)) {
        return (React.createElement(Router, { history: history },
            React.createElement(PortalRouter, { history: history })));
    }
    return (React.createElement(PageNotFound, { errorMessage: "There was an error fetching portal data." }));
};
export default withRouter(PortalContainer);
